import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { infoSourceService } from "@/services/information-source/infoSourceService";

export const useInformationSourceActions = () => {
  const { toast } = useToast();
  const { t } = useLanguage();
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleArchive = async (id: string) => {
    try {
      setIsLoading(true);
      await infoSourceService.archive(id, user?.uid);
      toast({
        title: t("success"),
        description: t("infoSources.archived"),
      });
    } catch (error) {
      console.error("Error archiving information source:", error);
      toast({
        title: t("error"),
        description: t("infoSources.archiveError"),
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleRestore = async (id: string) => {
    try {
      setIsLoading(true);
      await infoSourceService.restore(id, user?.uid);
      toast({
        title: t("success"),
        description: t("infoSources.restored"),
      });
    } catch (error) {
      console.error("Error restoring information source:", error);
      toast({
        title: t("error"),
        description: t("infoSources.restoreError"),
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleArchive,
    handleRestore,
    isLoading,
  };
};
